import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownPaymentMethodContext } from "./form-dropdown-payment-method.context";

export interface FormDropdownPaymentMethodProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownPaymentMethod<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownPaymentMethodProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newPaymentMethod,
    mappedPaymentMethod,
    isCreating,
    setSidebar,
    setFilter,
    setNewPaymentMethod,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownPaymentMethodContext();
  
  return (
    <div className="payment-method">
      {newPaymentMethod && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new paymentMethod</h2>
          <p>
            You are creating a new paymentMethod. Please, fill the fields to create a
            new paymentMethod and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="PaymentMethod Name"
              value={newPaymentMethod.name}
              onChange={(e: any) =>
                setNewPaymentMethod({ ...newPaymentMethod, name: e.target.value })
              }
            />
            <InputText
              placeholder="PaymentMethod Description"
              value={newPaymentMethod.description}
              onChange={(e: any) =>
                setNewPaymentMethod({ ...newPaymentMethod, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="PaymentMethod"
        options={ mappedPaymentMethod }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your paymentMethod"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownPaymentMethod;